import React, { useEffect, useState, useRef } from "react";
import TwoColumnLayout from "../layouts/TwoColumnLayout";
import { useParams } from "react-router-dom";
import { apiFetch } from "../utils/wkCommon";
import { isZh } from "../utils/language";
import "../styles/agendaReport.css";
import GearIcon from "../components/_icons";
import AgendaAttributeConfigModal from "../components/AgendaAttributeConfigModal";
import AgendaCrossNavMenu from "../components/AgendaCrossNavMenu";
import {
  renderTemplate,
  zhNumber,
  addDays,
  formatDate,
  getWeekday,
  renderTable
} from "../utils/reportUtils";

const API_URL = process.env.REACT_APP_BACKEND_URL;

/* =========================================================
   HELPERS
========================================================= */

function buildRundownVars(item){

  return {

    time:item.time,

    timeEnd:item.timeEnd,

    duration:item.duration,

    scheduleSubject:item.scheduleSubject,
    scheduleDesc:item.scheduleDesc,
    scheduleNotes:item.scheduleNotes,

    penceramah:item.penceramah,
    penerjemah:item.penerjemah

  };

}

function collectMembers(role){

  return [
    ...(role.InternalUmat || []),
    ...(role.ExternalUmat || []),
    ...(role.ExternalNonUmat || [])
  ];

}

function splitByGender(members){

  const male=[];
  const female=[];

  members.forEach(p=>{

    const g=p.gender||"";

    if(g.includes("乾")) male.push(p);
    else if(g.includes("坤")) female.push(p);
    else male.push(p);

  });

  return {male,female};

}

function renderPersonName(p, print) {

  const zh = p.name_zh || "";
  const id = p.name_id || "";

  if (print === "zh") {
    return `<span class="person-name">${zh || id}</span>`;
  }

  if (print === "id") {
    return `<span class="person-name">${id || zh}</span>`;
  }

  if (zh && id) {
    return `
      <span class="person-name">
        ${zh}<br/>
        <span class="name-id">${id}</span>
      </span>
    `;
  }

  return `
    <p class="person-name">
      ${zh}
    </p>
    <p class="name-id">
      ${id}
    </p>
  `;
}

/*
function renderPersonName(p,print){

  const zh=p.name_zh||"";
  const id=p.name_id||"";

  if(print==="zh"){
    return `<div class="person-name">${zh||id}</div>`;
  }

  if(print==="id"){
    return `<div class="person-name">${id||zh}</div>`;
  }

  if(zh && id){
    return `
      <div class="person-name">
        <div class="name-zh">${zh}</div>
        <div class="name-id">${id}</div>
      </div>
    `;
  }

  return `
    <div class="person-name single">
      ${zh||id}
    </div>
  `;
}
*/

function renderMembers(role,print){

  const members = collectMembers(role);

  if(!role.SeparateLineOfGender){

    return members
      .map(p=>renderPersonName(p,print))
      .join("　");

  }

  const {male,female}=splitByGender(members);

  let html="";

  if(male.length){

    html+=`
      <div class="gender-row">
        <span class="gender-label">乾</span>
        ${male.map(p=>renderPersonName(p,print)).join("　")}
      </div>
    `;
  }

  if(female.length){

    html+=`
      <div class="gender-row">
        <span class="gender-label">坤</span>
        ${female.map(p=>renderPersonName(p,print)).join("　")}
      </div>
    `;
  }

  return html;

}

function buildRoleGrid(roles){

  const grid={};

  roles.forEach(r=>{

    const row=r.Row||1;
    const col=r.Col||1;

    if(!grid[row]) grid[row]={};

    grid[row][col]=r;

  });

  return grid;

}

function isSpecialRole(role){

  return role.Label_zh==="獻供"
      || role.Label_zh==="前面叩首";

}

function renderSpecialRole(role,print){

  const members=collectMembers(role);

  const posLabels=[
    "前","前",
    "後","後",
    "端"
  ];

  return (

    <table className="personnel-special">

      <tbody>

        {members.map((p,i)=>{

          const label=posLabels[i]||"";

          return(
            <tr key={i}>

              <td className="ritual-label">
                {label}
              </td>

              <td
                dangerouslySetInnerHTML={{
                  __html:renderPersonName(p,print)
                }}
              />

            </tr>
          );

        })}

      </tbody>

    </table>

  );

}

function findServiceRole(personnels,labelZh){

  const groups = personnels?.GroupRole || [];

  for(const g of groups){

    for(const r of g.ServiceRole || []){

      if(r.Label_zh === labelZh){
        return r;
      }

    }

  }

  return null;

}

function getFinanceRundownItems(rundowns){

  const types = ["Pembuka","Topik/Sesi","Penutup"];

  const rows=[];

  rundowns.forEach(day=>{

    (day.items || []).forEach(item=>{

      if(types.includes(item.scheduleType)){
        rows.push(item);
      }

    });

  });

  return rows;

}

function renderAmount(v){

  if(!v || v===0) return "-";

  return v.toLocaleString("id-ID");

}

function financeLabelZh(name){

  const map = {

    "Donasi Peserta": "乾道班員",
    "Donasi Petugas": "辦事人員",

    "Buah": "水果",
    "Bunga": "鮮花",
    "Sarapan": "早點",
    "Makan Siang": "午餐",
    "Fotokopi": "影印",
    "Lainnya": "其他"

  };

  return map[name] || name;

}

function buildTimeline(items, startTime){

  if(!items?.length) return [];

  let current = startTime;

  function addMinutes(time, dur){
    if(!time) return time;

    const [h,m]=time.split(":").map(Number);
    const d=new Date();
    d.setHours(h);
    d.setMinutes(m+dur);

    return `${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`;
  }

  return items.map((item,idx)=>{

    const time = idx===0
      ? (item.time || startTime)
      : current;

    const end = addMinutes(time,item.duration||0);

    current = end;

    return {
      ...item,
      time,
      timeEnd:end
    };

  });

}

/* =========================================================
   MAIN PAGE
========================================================= */

export default function AgendaBookReport() {

  const { id } = useParams();

  const [agendaBook,setAgendaBook] = useState(null);
  const [loading,setLoading] = useState(true);
  const [error,setError] = useState(null);

  const [templates,setTemplates] = useState([]);
  const [selectedTemplateId,setSelectedTemplateId] = useState("");

  const [templateConfig,setTemplateConfig] = useState(null);

  const [visibleSections,setVisibleSections] = useState([]);

  const [showAttrModal, setShowAttrModal] = useState(false);
  const [agenda, setAgenda] = useState(null);

  const [showMenu, setShowMenu] = useState(false);

  /* ================= LOAD AGENDABOOK ================= */

  useEffect(()=>{

    async function load(){
      try{
        setLoading(true);

        const resp = await apiFetch(`/api/agendas/${id}?populate[0]=agenda_book&populate[1]=events&populate[2]=events.participants`);
        const agenda = resp?.data || resp;

        const book = agenda?.agenda_book;

        setAgenda(agenda);
        setAgendaBook(book || null);
      }catch(e){
        console.error(e);
        setError(e);
      }finally{
        setLoading(false);
      }
    }

    load();

  },[id]);

  /* ================= LOAD TEMPLATE ================= */

	useEffect(()=>{

		async function loadTemplates(){

			const resp = await apiFetch("/api/agenda-book-report-templates");

			console.log("template resp", resp);

			const list = resp?.data || [];

			setTemplates(list);

			if(!list.length) return;

			const def =
				list.find(x => x.isDefault === true) ||
				list[0];

			console.log("default template", def);

			setSelectedTemplateId(def.documentId);

			setTemplateConfig(def.configJson || {});

			setVisibleSections(
				(def.configJson?.sections || []).map(s=>s.key)
			);

		}

		loadTemplates();

	},[]);

  function handleTemplateChange(docId){

    setSelectedTemplateId(docId);

    const t = templates.find(x=>x.documentId===docId);

    if(!t) return;

    setTemplateConfig(t.configJson || {});

    setVisibleSections(
      (t.configJson?.sections || []).map(s=>s.key)
    );

  }

  if (loading) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", color: "#64748b" }}>
        {isZh() ? "載入中..." : "Loading..."}
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
        {isZh() ? "載入失敗" : "Failed to load data"}
      </div>
    );
  }

  if (!agendaBook) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", color: "#64748b" }}>
        {isZh() ? "尚未建立 Agenda Book" : "Agenda Book belum dibuat"}
      </div>
    );
  }

	if (!templateConfig) {
		return <div style={{padding:"2rem"}}>No template found.</div>;
	}

  const sections = templateConfig.sections || [];
  // styles
  const styles = {
    menuItem: {
      padding: "0.5rem 0.6rem",
      cursor: "pointer",
      borderRadius: "0.45rem",
      color: "#0b2540",
      transition: "background 0.15s ease, color 0.15s ease",
    },
  }

  function menuHoverProps() {
    return {
      onMouseEnter: (e) => {
        e.currentTarget.style.background = "#f1f5f9";
      },
      onMouseLeave: (e) => {
        e.currentTarget.style.background = "transparent";
      }
    };
  }

  return (
    <>
    <TwoColumnLayout
      title={isZh()?"報表預覽":"Report Preview"}
      variant="right60"

      headerActions={
        <>
          <button className="btn-icon" onClick={()=>setShowAttrModal(true)} title="議程設定 Konfigurasi Agenda">
            <GearIcon />
          </button>

          <div style={{ position: "relative" }}>
            <button className="btn-icon" onClick={()=>setShowMenu(s=>!s)}>⋯</button>

            {showMenu && (
              <div className="action-menu">
                <div
                  role="menuitem"
                  onClick={() => window.location.reload()}  
                  onKeyPress={(e) => { if (e.key === "Enter") window.location.reload(); }}
                  {...menuHoverProps()}
                  style={styles.menuItem}
                >
                  Refresh Data
                </div>

                <div style={{ margin: "0.5rem 0", borderBottom: "solid 1px #dedede" }}> </div>

                <AgendaCrossNavMenu
                  agendaId={id}
                  hasPreRegForm={!!agenda?.agenda_pre_reg_form}
                  onClose={()=>setShowMenu(false)}
                />
              </div>
            )}
          </div>
        </>
      }

      leftNode={

        <LeftPanel
          templates={templates}
          selectedTemplateId={selectedTemplateId}
          onTemplateChange={handleTemplateChange}
          visibleSections={visibleSections}
          setVisibleSections={setVisibleSections}
          sections={sections}
        />
      }

      rightNode={
        <ReportPreview
          agendaBook={agendaBook}
          templateConfig={templateConfig}
          sections={sections}
          visibleSections={visibleSections}
        />
      }
    />
    <AgendaAttributeConfigModal
      open={showAttrModal}
      onClose={()=>setShowAttrModal(false)}
      agendaId={id}
      agenda={agenda}
      agendaBook={agendaBook}
    />   
    </>    
  );
}

  function getAgendaReportCss() {
    let css = "";

    Array.from(document.styleSheets).forEach(sheet => {
      try {
        Array.from(sheet.cssRules || []).forEach(rule => {
          if (
            rule.cssText.includes(".report-") ||
            rule.cssText.includes(".header-line") ||
            rule.cssText.includes(".rundown-") ||
            rule.cssText.includes(".personnel-") ||
            rule.cssText.includes(".finance-") ||
            rule.cssText.includes(".subject-") ||
            rule.cssText.includes(".person-name") ||
            rule.cssText.includes(".gender-") ||
            rule.cssText.includes(".role-label") ||
            rule.cssText.includes(".ritual-label") ||
            rule.cssText.includes(".amount-wrap")
          ) {
            css += rule.cssText + "\n";
          }
        });
      } catch(err) {
        console.warn(
          "Cannot read stylesheet",
          sheet.href
        );
      }
    });
    return css;
  }


/* =========================================================
   LEFT PANEL
========================================================= */

function LeftPanel({
  templates,
  selectedTemplateId,
  onTemplateChange,
  visibleSections,
  setVisibleSections,
  sections
}){
  const [exporting, setExporting] = useState(false);

  function toggleSection(key){

    if(visibleSections.includes(key)){

      setVisibleSections(
        visibleSections.filter(x=>x!==key)
      );

    }else{

      setVisibleSections([...visibleSections,key]);

    }

  }

  function handlePrint() {

    try {

      setExporting(true);

      setTimeout(() => {
        window.print();
        setExporting(false);
      }, 100);

    } catch(err) {

      console.error(err);
      setExporting(false);

    }

  }

  async function exportGoogleDocs(){
    try{
      setExporting(true);

      const html =
        window.__REPORT_HTML__?.() || "";

      if(!html){
        alert("Report HTML not ready");
        return;
      }

      const css = getAgendaReportCss();

      const resp = await apiFetch(
        "/api/google/execute",
        {
          method:"POST",
          body:{
            contentType:"agenda-book",
            documentId:"preview",
            formatName:"report",
            file:{
              type:"document"
            },
            document:{
              html,
              css
            }
          }
        }
      );

      if(resp?.url){
        window.open(resp.url,"_blank");
      }

    }catch(err){

      console.error(err);

      alert("Export failed");

    }finally{

      setExporting(false);

    }
  }
  
  return(

    <div className="doc-left-panel">

      <div className="doc-section-title">
        Template
      </div>

      <select
        value={selectedTemplateId}
        onChange={(e)=>onTemplateChange(e.target.value)}
        style={{width:"100%",marginBottom:"1rem"}}
      >
        {templates.map(t=>(
          <option key={t.documentId} value={t.documentId}>
            {t.name_zh} / {t.name_id}
          </option>
        ))}
      </select>

      <div className="doc-section-title">
        Sections
      </div>

      {sections.map(s=>(
        <label key={s.key} style={{display:"block",marginBottom:"0.25rem"}}>

          <input
            type="checkbox"
            checked={visibleSections.includes(s.key)}
            onChange={()=>toggleSection(s.key)}
          />

          {" "}
          {s.title || s.key}

        </label>
      ))}

      <hr style={{margin:"1rem 0"}}/>

      <div className="doc-section-title">
        Export
      </div>

      <button
        className="btn-primary"
        disabled={exporting}
        style={{width:"100%",marginBottom:"0.5rem"}}
        onClick={handlePrint}
      >
        {exporting
          ? "Processing..."
          : "Export PDF"}
      </button>

      <button
        className="btn-secondary"
        disabled={exporting}
        style={{width:"100%"}}
        onClick={exportGoogleDocs}
      >
        {exporting
          ? "Processing..."
          : "Export Google Docs"}
      </button>

    </div>
  );
}

/* =========================================================
   REPORT HEADER
========================================================= */

function HeaderSection({agendaBook,templateConfig}){

  const header = templateConfig?.header || {};

	const attrs = agendaBook?.agendaAttributes || {};

	const vars = {

		agendaDate: attrs.agendaDateText || "",
		lunarDate: attrs.lunarDate || "",

		areaNameZh: attrs.areaNameZh || "",
		areaNameId: attrs.areaNameId || "",

		agendaSubjectZh: attrs.agendaSubjectZh || "",
		agendaSubjectId: attrs.agendaSubjectId || "",

		rundownSectionTitleZh: attrs.rundownSectionTitleZh || "",
		rundownSectionTitleId: attrs.rundownSectionTitleId || "",

		personnelSectionTitleZh: attrs.personnelSectionTitleZh || "",
		personnelSectionTitleId: attrs.personnelSectionTitleId || "",

		financeSectionTitleZh: attrs.financeSectionTitleZh || "",
		financeSectionTitleId: attrs.financeSectionTitleId || ""

	};

  return(

    <div className="report-header">

      {header.line1 && (
        <div className="header-line1">
          {renderTemplate(header.line1,vars)}
        </div>
      )}

      {header.line2 && (
        <div className="header-line2">
          {renderTemplate(header.line2,vars)}
        </div>
      )}

      {header.line3 && (
        <div className="header-line3">
          {renderTemplate(header.line3,vars)}
        </div>
      )}

    </div>

  );
}

/* =========================================================
   REPORT PREVIEW
========================================================= */

function ReportPreview({
  agendaBook,
  templateConfig,
  sections,
  visibleSections
}){
  const ref = useRef(null);

  useEffect(() => {

    window.__REPORT_HTML__ = () =>
      ref.current?.outerHTML || "";

    return () => {
      delete window.__REPORT_HTML__;
    };

  }, []);
	
  return(

    <div ref={ref} className="doc-main-panel report-container">

      {sections
        .sort((a,b)=>a.order-b.order)
        .filter(s=>visibleSections.includes(s.key))
        .map(section=>{

          return renderSection(section.key, templateConfig,agendaBook);

        })}

    </div>

  );
}

/* =========================================================
   SECTION RENDER ENGINE
========================================================= */

function renderSection(key,templateConfig,agendaBook){

  if(key==="header"){
    return (
      <HeaderSection
        key="header"
        templateConfig={templateConfig}
        agendaBook={agendaBook}
      />
    );
  }

  if(key==="rundown"){
    return (
			<RundownSection
				key="rundown"
				data={agendaBook?.agendaRundowns || []}
				templateConfig={templateConfig}
				agendaBook={agendaBook}
			/>
    );
  }

	if(key==="personnel"){
		return (
			<PersonnelSection
				key="personnel"
				data={agendaBook?.agendaPersonnels || {}}
				agendaBook={agendaBook}
			  templateConfig={templateConfig}
			/>
		);
	}

  if(key==="finances"){
    return (
      <FinanceSection
        key="finances"
        data={agendaBook?.agendaFinances || []}
				agendaBook={agendaBook}
			  templateConfig={templateConfig}
      />
    );
  }

  return null;
}

/* =========================================================
   RUNDOWN
========================================================= */

function RundownSection({data,templateConfig,agendaBook}){

  if(!data?.length) return null;

	const attrs = agendaBook?.agendaAttributes || {};

	const dayTemplate =
		templateConfig?.rundown?.dayTitle ||
		"第{{daySeqZh}}天 {{agendaDateSeq}}";

	const headerCfg = templateConfig?.rundown?.header;
	const tableCfg = templateConfig?.tables?.rundown;
		
	const singleDay = (data?.length || 0) <= 1;
  
	function calcEnd(start,dur){

    if(!start) return start;

    const [h,m]=start.split(":").map(Number);

    const d=new Date();

    d.setHours(h);
    d.setMinutes(m+dur);

    return `${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`;

  }

  return(

    <div className="report-section">

		<HeaderSection
			templateConfig={{header:headerCfg}}
			agendaBook={agendaBook}
		/>

		{data.map((day,i)=>{
      const timeline = buildTimeline(day.items, day.startTime);

			const dateObj = addDays(new Date(attrs.agendaDate), day.daySeq-1);
			const weekday = getWeekday(dateObj);
			const vars={
				daySeq:day.daySeq,
				daySeqZh:zhNumber(day.daySeq),
				agendaDateSeq:formatDate(dateObj),
				weekdayZh:weekday.zh,
				weekdayId:weekday.id
			};
			const title=renderTemplate(dayTemplate,vars);

			return(
        <div key={i} className="rundown-day">

					{!singleDay && (
						<div className="rundown-day-title">
							{title}
						</div>
					)}

            


					{
            /*
						day.items.map(item=>{
							const end = calcEnd(item.time,item.duration);
							return {
								...item,
								timeEnd:end,
								time:
									day.showEndTime
										? `${item.time} - ${end}`
										: item.time
							};
						}),
            */
            renderTable(

              timeline.map((item, idx)=>{
                const isLast = idx === timeline.length - 1;
                return {
                  ...item,
                  time:
                    day.showEndTime
                      ? `${item.time} - ${item.timeEnd}`
                      : item.time,
                  duration:
                    (!day.showEndTime && isLast)
                      ? ""   // sembunyikan
                      : item.duration
                };
              }),

              tableCfg,
              buildRundownVars

            )
          }

        </div>
			)
		})}

    </div>

  );
}

/* =========================================================
   PERSONNEL
========================================================= */

function PersonnelSection({data,agendaBook, templateConfig}){

  const print=data?.Print||"all";

  const groups=data?.GroupRole||[];

	const headerCfg = templateConfig?.personnel?.header;

  return(

    <div className="report-section">

			<HeaderSection
				templateConfig={{header:headerCfg}}
				agendaBook={agendaBook}
			/>

      {groups
        .sort((a,b)=>a.Row-b.Row)
        .map(group=>{

          const roles = (group.ServiceRole || [])
            .filter(r =>
              !(r.Label_zh === "授課" || r.Label_id === "Penceramah")
            )
            .sort((a, b) => {

              if (a.Row !== b.Row)
                return a.Row - b.Row;

              return (a.Col || 1) - (b.Col || 1);

            });

          const grid=buildRoleGrid(roles);

          const rows=Object.keys(grid)
            .map(Number)
            .sort((a,b)=>a-b);

          return(

            <div key={group.Row}>

              {group.ShowOnReport!==false && (
                <div className="personnel-group-title">
									<span className="group-zh">
										{group.Label_zh}
									</span>
									{""}
									<span className="group-id">
										{group.Label_id}
									</span>
                </div>
              )}

              <table className="personnel-table">

                <tbody>

                  {rows.map(r=>{

                    const c1=grid[r][1];
                    const c2=grid[r][2];

                    if(c1 && isSpecialRole(c1)){

                      return(
                        <tr key={r}>

                          <td className="role-label">
                            {c1.Label_zh}<br/>
                            <span className="label-id">{c1.Label_id}</span>
                          </td>

                          <td colSpan={3}>
                            {renderSpecialRole(c1,print)}
                          </td>

                        </tr>
                      );

                    }

                    return(

                      <tr key={r}>

                        {c1 && (

                          <>
                          <td className="role-label">
                            {c1.Label_zh}<br/>
                            <span className="label-id">{c1.Label_id}</span>
                          </td>

                          <td
                            dangerouslySetInnerHTML={{
                              __html:renderMembers(c1,print)
                            }}
                          />
                          </>

                        )}

                        {c2 && (

                          <>
                          <td className="role-label">
                            {c2.Label_zh}<br/>
                            <span className="label-id">{c2.Label_id}</span>
                          </td>

                          <td
                            dangerouslySetInnerHTML={{
                              __html:renderMembers(c2,print)
                            }}
                          />
                          </>

                        )}

                      </tr>

                    );

                  })}

                </tbody>

              </table>

            </div>

          );

        })}

    </div>

  );

}

/* =========================================================
   FINANCE
========================================================= */

function FinanceSection({data,agendaBook,templateConfig}){

  const headerCfg = templateConfig?.finance?.header;

  return(

    <div className="report-section">

      <HeaderSection
        templateConfig={{header:headerCfg}}
        agendaBook={agendaBook}
      />

      <FinanceSummaryTable
        agendaBook={agendaBook}
      />

      <FinanceAccountTable
        data={data}
      />

    </div>

  );
}

function FinanceSummaryTable({agendaBook}){

  const personnels = agendaBook?.agendaPersonnels || {};
  const rundowns = agendaBook?.agendaRundowns || [];

  const leaderRole = findServiceRole(personnels,"主班");
  const coordRole = findServiceRole(personnels,"操持");

  const leaderNames =
    leaderRole
      ? collectMembers(leaderRole)
          .map(p=>renderPersonName(p,"all"))
          .join("　")
      : "";

  const coordNames =
    coordRole
      ? collectMembers(coordRole)
          .map(p=>renderPersonName(p,"all"))
          .join("　")
      : "";

  const items = getFinanceRundownItems(rundowns);

  const financeBlock =
    agendaBook?.agendaFinances?.[0] || {};

  const participantSummary =
    financeBlock.participantSummary || {};

  const summary = {

    pesertaPria:
      Number(
        participantSummary?.pesertaMale?.count || 0
      ),

    pesertaWanita:
      Number(
        participantSummary?.pesertaFemale?.count || 0
      ),

    petugasPria:
      Number(
        participantSummary?.petugasMale?.count || 0
      ),

    petugasWanita:
      Number(
        participantSummary?.petugasFemale?.count || 0
      )

  };

  summary.totalPeserta =
    summary.pesertaPria +
    summary.pesertaWanita;

  summary.totalPetugas =
    summary.petugasPria +
    summary.petugasWanita;
			
  return(

    <div className="finance-summary">

			<table className="finance-role-table">

				<tbody>

					<tr>
						<td className="finance-role-label">
							主班：<br/>
							<span className="finance-role-id">
								PEMIMPIN KELAS
							</span>
						</td>

						<td
							className="finance-role-members"
							dangerouslySetInnerHTML={{__html:leaderNames}}
						/>
					</tr>

					<tr>
						<td className="finance-role-label">
							操持：<br/>
							<span className="finance-role-id">
								KOORDINATOR
							</span>
						</td>

						<td
							className="finance-role-members"
							dangerouslySetInnerHTML={{__html:coordNames}}
						/>
					</tr>

				</tbody>

			</table>

      <table className="finance-summary-table rundown">

        <thead>

          <tr>

            <th style={{width:"50px"}}>
              編號<br/><span className="label-id">NO</span>
            </th>

            <th>
              課題<br/><span className="label-id">TOPIK</span>
            </th>

            <th style={{width:"120px"}}>
              授課<br/><span className="label-id">PENCERAMAH</span>
            </th>

            <th style={{width:"120px"}}>
              翻譯<br/><span className="label-id">PENERJEMAH</span>
            </th>

            <th style={{width:"120px"}}>
              備註<br/><span className="label-id">KETERANGAN</span>
            </th>

          </tr>

        </thead>

        <tbody>

          {items.map((it,i)=>(

            <tr key={i}>

              <td style={{textAlign:"center"}}>
                {i+1}
              </td>

              <td>
                {it.scheduleSubject}
              </td>

              <td style={{ textAlign:"center" }}>
                {it.penceramah || ""}
              </td>

              <td style={{ textAlign:"center" }}>
                {it.penerjemah || ""}
              </td>

              <td>
              </td>

            </tr>

          ))}

        </tbody>

      </table>

			<table className="finance-participant-summary">
				<tbody>
					<tr>
						<td className="label">
							班員人數 :
						</td>
						<td>
							乾&nbsp;&nbsp;{summary.pesertaPria}位
						</td>
						<td>
							坤&nbsp;&nbsp;{summary.pesertaWanita}位
						</td>
						<td>
							合計&nbsp;&nbsp;{summary.totalPeserta}位
						</td>
					</tr>
					<tr>
						<td className="label">
							辦事人數 :
						</td>
						<td>
							乾&nbsp;&nbsp;{summary.petugasPria}位
						</td>
						<td>
							坤&nbsp;&nbsp;{summary.petugasWanita}位
						</td>
						<td>
							合計&nbsp;&nbsp;{summary.totalPetugas}位
						</td>
					</tr>
					<tr>
						<td colSpan="3"></td>
						<td className="grand-total">
							總計&nbsp;&nbsp;
							{summary.totalPeserta + summary.totalPetugas}位
						</td>
					</tr>
				</tbody>
			</table>

    </div>

  );

}

function FinanceAccountTable({data}){

  const block = data?.[0] || {};

  const incomes = block?.incomes || [];
  const expenses = block?.expenses || [];

  const incomeTotal =
    incomes.reduce((s,x)=>s+(x.recordedAmount||0),0);

  const expenseTotal =
    expenses.reduce((s,x)=>s+(x.recordedAmount||0),0);

  const grandTotal =
    incomeTotal - expenseTotal;

  return(

    <table className="finance-table">
      <tbody>
        {/* 收入 */}
        <tr>
          <td className="finance-label">
            收入 (助班費)：
          </td>
          <td className="finance-amount">
          </td>
        </tr>
        {incomes.map((x,i)=>(
          <tr key={i}>
            <td className="finance-label sub">
              {financeLabelZh(x.transactionName)}
            </td>
            <td className="finance-amount">
							<div className="amount-wrap">
								<span className="currency">Rp</span>
								<span className="amount">{renderAmount(x.recordedAmount)}</span>
							</div>
	          </td>
          </tr>
        ))}
        <tr className="finance-subtotal">
          <td className="finance-label subtotal">
            總收入
          </td>
          <td className="finance-amount">
						<div className="amount-wrap">
							<span className="currency">Rp</span>
							<span className="amount">{renderAmount(incomeTotal)}</span>
						</div>
          </td>
        </tr>
        {/* 支出 */}
        <tr>
          <td className="finance-label">
            支出：
          </td>
          <td className="finance-amount">
          </td>
        </tr>
        {expenses.map((x,i)=>(
          <tr key={i}>
            <td className="finance-label sub">
              {financeLabelZh(x.transactionName)}
            </td>
            <td className="finance-amount">
							<div className="amount-wrap">
								<span className="currency">Rp</span>
								<span className="amount">{renderAmount(x.recordedAmount)}</span>
							</div>
            </td>
          </tr>
        ))}
        <tr className="finance-subtotal">
          <td className="finance-label subtotal">
            總支出
          </td>
          <td className="finance-amount">
						<div className="amount-wrap">
							<span className="currency">Rp</span>
							<span className="amount">{renderAmount(expenseTotal)}</span>
						</div>
          </td>
        </tr>
        <tr className="finance-grand">
          <td className="finance-label subtotal">
            總金額
          </td>
          <td className="finance-amount">
						<div className="amount-wrap">
							<span className="currency">Rp</span>
							<span className="amount">{renderAmount(grandTotal)}</span>
						</div>
          </td>
        </tr>
      </tbody>
    </table>

  );

}
